import * as v from "valibot";
import {
  SortOrder,
  SourcingProcurementMethod,
  SourcingRejectedBy,
  SourcingTagConfidence,
  SourcingTagStatus,
  SourcingTenderEntrySortColumn,
  SourcingTenderEntrySource,
  SourcingTenderEntryStatus,
  SourcingTenderEntryWindow,
} from "@/shared/gql/graphql";
import {
  DEFAULT_ENTRY_SORT,
  type EntrySort,
} from "@/features/sourcing-tender-entry-review/model/entry-sort";

export const searchParams = v.object({
  q: v.optional(v.string()),
  status: v.optional(v.enum(SourcingTenderEntryStatus)),
  rejectedBy: v.optional(v.enum(SourcingRejectedBy)),
  rejectionReason: v.optional(v.string()),
  source: v.optional(v.enum(SourcingTenderEntrySource)),
  missing: v.optional(v.boolean()),
  hasSource: v.optional(v.boolean()),
  tagStatus: v.optional(v.enum(SourcingTagStatus)),
  tagConfidence: v.optional(v.enum(SourcingTagConfidence)),
  possibleDuplicates: v.optional(v.boolean()),
  published: v.optional(v.boolean()),
  method: v.optional(v.enum(SourcingProcurementMethod)),
  year: v.optional(v.pipe(v.number(), v.integer())),
  window: v.optional(v.enum(SourcingTenderEntryWindow)),
  sort: v.optional(v.enum(SourcingTenderEntrySortColumn)),
  order: v.optional(v.enum(SortOrder)),
  page: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
});

export type SourcingEntriesSearch = v.InferOutput<typeof searchParams>;

export const entrySortOf = (search: SourcingEntriesSearch): EntrySort => ({
  column: search.sort ?? DEFAULT_ENTRY_SORT.column,
  direction: search.order ?? DEFAULT_ENTRY_SORT.direction,
});

/** Paging and sorting change what is shown, not which entries match. */
export const isFiltered = ({
  page: _page,
  sort: _sort,
  order: _order,
  ...filters
}: SourcingEntriesSearch) =>
  Object.values(filters).some((value) => value !== undefined);
